/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobThreadRequest {
    getFixupPrototypeFunction() { return BackgroundJobThreadRequest.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobThreadRequest>): BackgroundJobThreadRequest {
        let obj = Object.assign(new BackgroundJobThreadRequest(), model);
        BackgroundJobThreadRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobThreadRequest>): BackgroundJobThreadRequest {
        if (!model) return null;
        return BackgroundJobThreadRequest.newInstance(<BackgroundJobThreadRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobThreadRequest) {
        if (!obj) return;

        models.BackgroundJobThreadRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobThreadRequest): boolean {
        Object.setPrototypeOf(obj, BackgroundJobThreadRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Filter to threads in this executor
     */
    executor: models.BackgroundJobExecutor;

}
